"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "DynamicGmap", {
  enumerable: true,
  get: function () {
    return _DynamicGmap.default;
  }
});
_Object$defineProperty(exports, "StaticGmap", {
  enumerable: true,
  get: function () {
    return _StaticGmap.default;
  }
});
exports.default = void 0;
_Object$defineProperty(exports, "getMapContainerCorners", {
  enumerable: true,
  get: function () {
    return _map.getMapContainerCorners;
  }
});
var _DynamicGmap = _interopRequireDefault(require("./components/DynamicGmap/DynamicGmap"));
var _StaticGmap = _interopRequireDefault(require("./components/StaticGmap/StaticGmap"));
var _map = require("./lib/map.utils");
// for backwards compatibility. Prefer to use the named exports going forwards.
var _default = exports.default = _DynamicGmap.default;